import React, {useState, useEffect} from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import mainMenus from "../config/menuConfig";
import Login from "../pages/Login";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import config from "../config/config";
import pageConfig from "../config/pageConfig";
import {useUser, UserProvider} from "../context/UserContext";
import useIsMobile from "../hooks/useIsMobile";
const API_URL = config.API_URL;

function ProtectedRoute({variants, defaultElement, requiredAuthority}){
  const { isLoggedIn, authority} = useUser();
  const navigate = useNavigate(); 

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }


  // ✅ 권한 체크 함수
  const getElementByAuthority = () => {
    if (variants) {
      // variants 배열에서 권한이 맞는 컴포넌트를 찾음
      const matchedVariant = variants.find((variant) => {
        return variant.authority.includes(authority);
      });
      return matchedVariant ? matchedVariant.element : null;
    }

    return defaultElement; // 기본 element 렌더링
  };
  
  // const [isSessionValid, setIsSessionValid] = useState(null); // 초기 상태: null

  const hasAuthority = () => {
    if (!requiredAuthority) return true; // 권한이 명시되지 않은 경우 허용
    return requiredAuthority.includes(authority); // 배열에 현재 authority가 포함되어 있는지 확인
  };

  const elementToRender = getElementByAuthority();

  if (!elementToRender || !hasAuthority()) {
    // console.log("elementToRender: ", elementToRender, 'has authority:', hasAuthority());
    alert("🚫 권한이 없는 페이지입니다.");
    navigate("/login");
    return null;
  }

  return elementToRender;

}



function AppRoutes() {
  return(
    <UserProvider>
      <Router>
        <InnerAppRoutes/>
      </Router>
    </UserProvider>
  )
}

function InnerAppRoutes(){
  const isMobile = useIsMobile();
  const location = useLocation(); // 이제 Router 컨텍스트 안에서 호출 가능
  const { isLoggedIn, authority} = useUser();

  const renderRoutes = (menuList, basePath = "") => {
    return menuList.map(({ path, element, lowerMenu, authority, variants }) => {
      const fullPath = basePath
        ? `${basePath}${path}`.replace(/\/+/g, "/").replace(/\/$/, "")
        : path;
  
      return (
        <React.Fragment key={fullPath}>
          {!lowerMenu && ( 
            <Route
              path={fullPath}
              element={
                <ProtectedRoute
                  variants={variants} // ✅ variants 전달
                  defaultElement={element} // 기본 element
                  requiredAuthority={authority} // 권한 체크
                />
              }
            />
          )}
          
          {lowerMenu && renderRoutes(lowerMenu, fullPath)}
        </React.Fragment>
      );
    });
  };

  if(isMobile){
    return (
      <div style={mobileStyles.container}>
        {isLoggedIn && <Sidebar />}
        <div style={mobileStyles.content}>
          <Routes>
            <Route
              path="/login"
              element={isLoggedIn ?
                <Navigate to="/commute" />
                : <Login />}
            />

            {/* 메뉴 리스트 */}
            {renderRoutes(mainMenus)}

            {/* 보호 페이지 */}
            {renderRoutes(pageConfig.protectedPages)}

            {/* 일반페이지 */}
            {pageConfig.publicPages.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}

            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
          {/* {isLoggedIn() && <Footer />} */}
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {isLoggedIn && <Sidebar />}
      <div style={styles.content}>
        {isLoggedIn && <Header />}
        <Routes>
          <Route
            path="/login"
            element={isLoggedIn ? <Navigate to="/my_page" /> : <Login />}
          />

          {/* 메뉴 리스트 */}
          {renderRoutes(mainMenus)}

          {/* 보호 페이지 */}
          {renderRoutes(pageConfig.protectedPages)}

          {/* 일반페이지 */}
          {pageConfig.publicPages.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
        {/* {isLoggedIn() && <Footer />} */}
      </div>
    </div>
  );
}


const styles = {
  container: {
    width: "1440px",
    height: "100vh",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  },
  content: {
    flex: 1,
    width: "100%",
    height: "100%",
    backgroundColor: "#f4f4f4",
    display: "flex",
    flexDirection: "column",
  },
};

const mobileStyles = {
  container: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  content: {
    flex: 1,
    width: "100%",
    height: "100%",
    backgroundColor: "#f4f4f4",
    display: "flex",
    flexDirection: "column",
  },
};

export default AppRoutes;